import { render, staticRenderFns } from "./AsACoachTab.vue?vue&type=template&id=e0d36282&scoped=true"
import script from "./AsACoachTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachTab.vue?vue&type=style&index=0&id=e0d36282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d36282",
  null
  
)

export default component.exports